import { SCRIPT_NAME } from "common/constants";

import { isLocalhost } from "./environment";

export const extractHostname = (url: string) => {
    const a = document.createElement("a");
    a.href = url;

    return a.hostname || url.split(":")[0];
};

export const extractRootDomain = (url: string) => {
    const hostname = extractHostname(url);
    const hostnameParts = hostname.split(".");
    const partLength = hostnameParts.length;

    if (partLength <= 2) {
        return hostname;
    }

    const [part1, part2, part3] = hostnameParts.splice(partLength - 3);
    const hasCountryCodeTopLevelDomain = part2.length === 2 && part3.length === 2; // (i.e. ".me.uk")

    return hasCountryCodeTopLevelDomain ? [part1, part2, part3].join(".") : [part2, part3].join(".");
};

export const getCurrentDomain = (): string => {
    const src =
        (document.currentScript as HTMLScriptElement)?.src ||
        document.querySelector(`script[src$="${SCRIPT_NAME}"]`)?.getAttribute("src");

    return src ? extractHostname(src) : window.location.hostname;
};

export const convertWidgetUrlToLinkFormUrl = (origin: string) => {
    if (isLocalhost()) {
        return LINK_FORM_URL;
    }

    if (origin.startsWith("https://widget")) {
        return origin.replace("https://widget", "https://checkout");
    }

    if (origin.startsWith("https://other-widget")) {
        return origin.replace("https://other-widget", "https://other-checkout");
    }

    return LINK_FORM_URL;
};
